// extracted by mini-css-extract-plugin
export default {"title":"index_title-Z2k5j"};